import React, { useState } from "react";
import { useField } from "formik";

import { FieldSet, Input, Error, InputWrapper } from "./checkbox.style";

interface ICheckBoxProps {
  label: string;
  name: string;
}

const CheckBoxComponent: React.FC<
  ICheckBoxProps & Omit<React.HTMLProps<HTMLInputElement>, "label">
> = (
  props: ICheckBoxProps & Omit<React.HTMLProps<HTMLInputElement>, "label">
) => {
  const { name, label } = props;
  const [field, meta, helpers] = useField(name);
  const { setValue } = helpers;

  return (
    <FieldSet>
      <InputWrapper>
        <Input type="checkbox" checked={field.value} {...field} {...props} />
        <label onClick={() => setValue(!field.value)}>{label}</label>
      </InputWrapper>

      {meta.touched && meta.error ? <Error>{meta.error}</Error> : null}
    </FieldSet>
  );
};

export default CheckBoxComponent;
